import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useCart } from '../Context/CartContext';
import AddressModal from "../components/Ui/AdressModal";
import { Button } from "@mui/material";
import { addAddress,getUserAddresses,submitCardPayment } from '../services/userService';
import { useNotification } from "../components/NotificationContext";
import { getShippingFee } from '../services/userService';
const CheckoutPage = () => {
  const navigate = useNavigate();
  const showNotification = useNotification();
  const { items, getCartTotal, clearCart } = useCart();
  const [modalOpen, setModalOpen] = useState(false);
  const [is3DSActive, setIs3DSActive] = useState(false);
  const [overlayText, setOverlayText] = useState("Ödeme başlatılıyor…");
  const [canCloseOverlay, setCanCloseOverlay] = useState(false);
  const [shippingInfo, setShippingInfo] = useState({
    orderMinPay: 0,
    totalAmount: getCartTotal(),
    shippingFee: 0,
  });
  const [formData, setFormData] = useState({
    cardName: '',
    cardNumber: '',
    expiry: '',
    cvv: '',
  });
  const [addressData, setAddressData] = useState({
    title: '',
    state: '',
    address: '',
    is_same_as_delivery: true, // checkbox başlangıçta seçili olacak
    full_name: '',
    billing_state: '',
    billing_address: '',
    tax_number: '',
    tax_office: ''
  });
  const [addresses, setAddresses] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [paymentStep, setPaymentStep] = useState(1);
  const [selectedAddressId, setSelectedAddressId] = useState(null);

  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Redirect to cart if cart is empty
    if (items.length === 0) {
      navigate('/cart');
    }
  }, [items.length, navigate]);
  useEffect(() => {
    const fetchShippingInfo = async () => {
      const data = await getShippingFee();
      setShippingInfo(data);
    };

    fetchShippingInfo();
  }, []);
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
  
    if (type === 'checkbox') {
      setFormData((prev) => ({
        ...prev,
        [name]: checked,
      }));
      return;
    }
  
    // Kart numarası formatlama
    if (name === 'cardNumber') {
      const formatted = value.replace(/\s/g, '').replace(/(\d{4})/g, '$1 ').trim();
      setFormData((prev) => ({ ...prev, [name]: formatted }));
      return;
    }
  
    // Son kullanma tarihi formatlama
    if (name === 'expiry') {
      const formatted = value
        .replace(/\s/g, '')
        .replace(/(\d{2})(\d{2})/, '$1/$2')
        .replace(/\/\//, '/');
      setFormData((prev) => ({ ...prev, [name]: formatted }));
      return;
    }
  
    // Diğer tüm inputlar
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchAddresses = async () => {
      try {
        const data = await getUserAddresses();
        setAddresses(data);
      } catch (err) {
        console.error("Adresler alınamadı", err);
      }
    };
  
    if (paymentStep === 1) fetchAddresses();
  }, [paymentStep]);
  const cartTotal = Number(getCartTotal()); // güvenli dönüşüm
  const shippingFee = Number(shippingInfo.shippingFee); // güvenli dönüşüm
  
  const isFreeShipping = cartTotal >= Number(shippingInfo.orderMinPay);
  
  const finalTotal = isFreeShipping ? cartTotal : cartTotal + shippingFee;

const handleAddressSubmit = async () => {
  const newErrors = {};

  // 1) Form state'inden değerleri al
  const {
    title,
    state,
    address,
    is_same_as_delivery,
    full_name,
    billing_state,
    billing_address,
    tax_number,
    tax_office,
  } = addressData;

  // 2) Validation (addressData üzerinden)
  if (!title?.trim()) newErrors.title = 'Başlık gerekli';
  if (!state?.trim()) newErrors.state = 'İlçe gerekli';
  if (!address?.trim()) newErrors.address = 'Adres gerekli';

  if (!is_same_as_delivery) {
    if (!full_name?.trim()) newErrors.full_name = 'Ad Soyad gerekli';
    if (!billing_state?.trim()) newErrors.billing_state = 'İlçe gerekli';
    if (!billing_address?.trim()) newErrors.billing_address = 'Adres gerekli';
    if (!tax_number?.trim()) newErrors.tax_number = 'Vergi numarası gerekli';
    if (!tax_office?.trim()) newErrors.tax_office = 'Vergi dairesi gerekli';
  }

  if (Object.keys(newErrors).length) {
    setErrors(newErrors);
    return;
  }

  // 3) API payload (backend’in beklediği isimlere map et)
  const payload = {
    title,
    district: state,          // backend "district" bekliyorsa böyle bırak
    address,
    is_same_as_delivery,
    ...(is_same_as_delivery ? {} : {
      billingName: full_name,
      billingDistrict: billing_state,
      billingAddress: billing_address,
      taxNumber: tax_number,
      taxOffice: tax_office,
    }),
  };

  try {
    await addAddress(payload);
    const updated = await getUserAddresses();
    setAddresses(updated);
    setModalOpen(false);
    setAddressData({
      title: '',
      state: '',
      address: '',
      full_name: '',
      billing_state: '',
      billing_address: '',
      tax_office: '',
      tax_number: '',
      is_same_as_delivery: true,
    });
    setErrors({});
    showNotification('Adres Başarıyla eklendi!', 'success');
    localStorage.setItem('notificationSeverity', 'success');
  } catch (err) {
    showNotification('Adres Eklenemedi!', 'error');
    localStorage.setItem('notificationSeverity', 'error');
  }
};

  const validateForm = () => {
    const newErrors = {};
    
    // Validate first step
    if (paymentStep === 1) {
      if(!selectedAddressId){
        showNotification('Adres Seçiniz!', 'error');
        localStorage.setItem('notificationSeverity', 'error');
        newErrors.cardNumber = 'Adres Seçiniz';
      }
    }
    
    
    // Validate second step
    if (paymentStep === 2) {
      if (!formData.cardName) newErrors.cardName = 'Kart üzerindeki isim gerekli';
      if (!formData.cardNumber) {
        newErrors.cardNumber = 'Kart numarası gerekli';
      } else if (formData.cardNumber.replace(/\s/g, '').length !== 16) {
        newErrors.cardNumber = 'Geçerli bir kart numarası giriniz';
      }
      if (!formData.expiry) {
        newErrors.expiry = 'Son kullanma tarihi gerekli';
      } else if (!/^\d{2}\/\d{2}$/.test(formData.expiry)) {
        newErrors.expiry = 'Geçerli bir son kullanma tarihi giriniz (AA/YY)';
      }
      if (!formData.cvv) {
        newErrors.cvv = 'CVV gerekli';
      } else if (!/^\d{3}$/.test(formData.cvv)) {
        newErrors.cvv = 'Geçerli bir CVV giriniz';
      }
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleStepOne = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setPaymentStep(2);
      window.scrollTo(0, 0);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    const id = localStorage.getItem('id');
    setIsSubmitting(true);
    const totalAmount = finalTotal; // 💰 sepet toplam tutar
    // 💳 Kart bilgilerini submitCardPayment formatına dönüştür
    const cardDetails = {
      cardNumber: formData.cardNumber,
      expiry: formData.expiry,
      cvc: formData.cvv,
      cardName: formData.cardName,
      totalAmount: totalAmount,
      addressId: selectedAddressId,
      userId: id,
      cartItems: items.map((item) => ({
        id: item.productId,  // ya da item._id kullanıyorsan ona göre güncelle
        quantity: item.quantity,
        color: item.product.color, 
        size: item.product.size,  
        price:item.product.price
      })),
    };

    


    try {
    const { started } = await submitCardPayment(cardDetails, selectedAddressId);
    if (started) {
      setIs3DSActive(true);
      setOverlayText("3D Secure doğrulaması bekleniyor…");
      showNotification('3D Secure penceresi açıldı. Lütfen doğrulamayı tamamlayın.', 'info');
    }
    } catch (err) {
      console.error('Ödeme sırasında hata:', err);
      showNotification('Bir hata oluştu. Lütfen tekrar deneyin.', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
  // backend'in 3DS OK/FAIL HTML'ini hangi origin'den gönderdiğini kabul et
  const allowedOrigins = (() => {
    const arr = [window.location.origin];
    try {
      if (process.env.REACT_APP_API_URL) {
        arr.push(new URL(process.env.REACT_APP_API_URL).origin);
      }
      if (process.env.REACT_APP_PUBLIC_BASE_URL) {
        arr.push(new URL(process.env.REACT_APP_PUBLIC_BASE_URL).origin);
      }
    } catch {}
    return Array.from(new Set(arr.filter(Boolean)));
  })();

  const onMsg = (e) => {
//     const trusted = allowedOrigins.includes(e.origin) || e.origin === "null";
// if (!trusted) return;


    const data = e.data || {};
    if (data.type !== '3DS_RESULT') return;

    if (data.status === 'success') {
      setOverlayText("Ödeme başarıyla alındı. Yönlendiriliyorsunuz…");
      clearCart();
      showNotification('Ödeme başarıyla tamamlandı!', 'success');

      // popup'a ACK gönder (backend ACK dinliyorsa daha hızlı kapanır)
      try { e.source?.postMessage({ type: '3DS_ACK' }, e.origin); } catch {}

      navigate(`/payment/success?order=${data.orderId}`);
    } else {
      setIs3DSActive(false);
      showNotification(data.message || 'Ödeme başarısız.', 'error');
      try { e.source?.postMessage({ type: '3DS_ACK' }, e.origin); } catch {}
      // istersen burada navigate('/payment/fail') de yapabilirsin
    }
  };

  window.addEventListener('message', onMsg);
  return () => window.removeEventListener('message', onMsg);
}, [clearCart, navigate, showNotification]);

useEffect(() => {
  if (is3DSActive) {
    const t = setTimeout(() => setCanCloseOverlay(true), 15000);
    return () => clearTimeout(t);
  } else {
    setCanCloseOverlay(false);
  }
}, [is3DSActive]);
  
  

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen py-12 bg-secondary-light"
    >
      <div className="container-custom">
        <h1 className="mb-4 text-3xl font-bold text-gray-dark">Ödeme</h1>
        
        {/* Checkout steps */}
        <div className="flex mb-8">
          <div className={`flex-1 p-3 text-center ${paymentStep === 1 ? 'bg-primary text-white' : 'bg-white text-gray-dark'} rounded-l-lg`}>
            1. Adres Bilgileri
          </div>
          <div className={`flex-1 p-3 text-center ${paymentStep === 2 ? 'bg-primary text-white' : 'bg-white text-gray-dark'} rounded-r-lg`}>
            2. Ödeme Bilgileri
          </div>
        </div>
        
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          {/* Form */}
          <div className="lg:col-span-2">
            <div className="p-6 bg-white rounded-lg shadow-medium">
              {paymentStep === 1 ? (
  <>
  <h2 className="mb-4 text-lg font-semibold">Adreslerim</h2>

  {addresses.length === 0 ? (
    <p className="mb-4 text-gray-600">Kayıtlı adresiniz yok.</p>
  ) : (
<ul className="mb-4 space-y-2 overflow-y-auto max-h-64">
  {addresses.map((address) => (
    <li
      key={address.id}
      onClick={() => setSelectedAddressId(address.id)}
      className={`border p-3 rounded-md cursor-pointer transition 
        ${selectedAddressId === address.id ? 'border-primary bg-secondary' : 'hover:bg-gray-50'}`}
    >
      <p><strong>{address.title}</strong></p>
      <p>{address.address}</p>
      <p>{address.state}</p>
    </li>
  ))}
</ul>
  )}
<div className="flex items-center justify-between w-full">
<Button
  sx={{
    backgroundColor: '#bb3570', // Material-UI renk paletini kullanabilirsiniz
    color: 'white',
    '&:hover': {
      backgroundColor: '#e3b1d2', // Hover efekti
    }
  }}
  variant="contained"
  onClick={() => setModalOpen(true)}
>
  Adres Ekle
</Button>

<Button
  sx={{
    backgroundColor: '#bb3570', 
    color: 'white',
    '&:hover': {
      backgroundColor: '#e3b1d2',
    }
  }}
  variant="contained"
  onClick={handleStepOne}
  disabled={!selectedAddressId}
>
  Devam Et
</Button>

</div>




  <AddressModal
    isOpen={modalOpen}
    onClose={() => setModalOpen(false)}
    onSubmit={handleAddressSubmit} // bu fonksiyon modal içinden form submit olduğunda çağrılmalı
    formData={addressData}
    setFormData={setAddressData}
    errors={errors}
  />
</>
              ) : (
                <form onSubmit={handleSubmit}>
                  <h2 className="mb-6 text-xl font-medium text-gray-dark">Ödeme Bilgileri</h2>
                  
                  <div className="mb-6">
                    <label htmlFor="cardName" className="block mb-1 text-gray-dark">Kart Üzerindeki İsim</label>
                    <input
                      type="text"
                      id="cardName"
                      name="cardName"
                      value={formData.cardName}
                      onChange={handleChange}
                      className={`w-full p-2 border rounded-md focus:outline-none focus:ring-1 ${errors.cardName ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-primary'}`}
                    />
                    {errors.cardName && <p className="mt-1 text-sm text-red-500">{errors.cardName}</p>}
                  </div>
                  
                  <div className="mb-6">
                    <label htmlFor="cardNumber" className="block mb-1 text-gray-dark">Kart Numarası 5188 9619 3919 2544</label>
                    <input
                      type="text"
                      id="cardNumber"
                      name="cardNumber"
                      value={formData.cardNumber}
                      onChange={handleChange}
                      placeholder="XXXX XXXX XXXX XXXX"
                      maxLength={19}
                      className={`w-full p-2 border rounded-md focus:outline-none focus:ring-1 ${errors.cardNumber ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-primary'}`}
                    />
                    {errors.cardNumber && <p className="mt-1 text-sm text-red-500">{errors.cardNumber}</p>}
                  </div>
                  
                  <div className="grid grid-cols-1 gap-4 mb-6 sm:grid-cols-2">
                    <div>
                      <label htmlFor="expiry" className="block mb-1 text-gray-dark">Son Kullanma Tarihi 06/29</label>
                      <input
                        type="text"
                        id="expiry"
                        name="expiry"
                        value={formData.expiry}
                        onChange={handleChange}
                        placeholder="AA/YY"
                        maxLength={5}
                        className={`w-full p-2 border rounded-md focus:outline-none focus:ring-1 ${errors.expiry ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-primary'}`}
                      />
                      {errors.expiry && <p className="mt-1 text-sm text-red-500">{errors.expiry}</p>}
                    </div>
                    <div>
                      <label htmlFor="cvv" className="block mb-1 text-gray-dark">CVV 588</label>
                      <input
                        type="text"
                        id="cvv"
                        name="cvv"
                        value={formData.cvv}
                        onChange={handleChange}
                        placeholder="XXX"
                        maxLength={3}
                        className={`w-full p-2 border rounded-md focus:outline-none focus:ring-1 ${errors.cvv ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-primary'}`}
                      />
                      {errors.cvv && <p className="mt-1 text-sm text-red-500">{errors.cvv}</p>}
                    </div>
                  </div>
                  
                  <div className="flex justify-between">
                    <button
                      type="button"
                      onClick={() => setPaymentStep(1)}
                      className="px-6 py-2 transition-colors border border-gray-300 rounded-md text-gray-dark hover:bg-gray-50"
                    >
                      Geri
                    </button>
                    <button
                      type="submit"
                      className="btn-primary"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'İşleniyor...' : 'Ödemeyi Tamamla'}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
          
          {/* Order Summary */}
          <div className="lg:col-span-1">
            <div className="sticky p-6 bg-white rounded-lg shadow-medium top-20">
              <h2 className="mb-6 text-xl font-medium text-gray-dark">Sipariş Özeti</h2>
              
              <div className="mb-6 space-y-4">
                {items.map((item) => (
                  <div key={item.uniqueKey} className="flex items-center justify-between">
                    <div className="flex items-center">
                      <img 
                        src={`${process.env.REACT_APP_BASE_URL}${item.product.photo_url}`} 
                        alt={item.product.name}
                        className="object-contain w-10 h-10 mr-3 rounded-md"
                      />
                      <span className="text-gray-dark">{item.product.name} <span className="text-gray">x{item.quantity}</span></span>
                      
                    </div>
 
                    <span className="font-medium text-gray-dark">{(item.product.price * item.quantity).toFixed(2)} ₺</span>
                  </div>
                ))}
              </div>
              
              <div className="pt-4 space-y-4 border-t border-gray-200">
                <div className="flex justify-between">
                  <span className="text-gray">Ara Toplam</span>
                  <span className="font-medium text-gray-dark">{getCartTotal().toFixed(2)} ₺</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray">Kargo</span>
                  {getCartTotal() >= shippingInfo.orderMinPay ? (
    <span className="font-medium text-green-600">Ücretsiz</span>
  ) : (
    <div className="text-right">
      <div className="font-medium text-gray-dark">
        {shippingInfo.shippingFee.toLocaleString()} TL
      </div>
      <div className="text-xs text-gray">
        {`${(shippingInfo.orderMinPay - getCartTotal()).toLocaleString()} TL daha harcayın, kargo ücretsiz olsun`}
      </div>
    </div>
    
  )}
                </div>
                <div className="pt-4 border-t border-gray-200">
                <div className="flex justify-between">
  <span className="text-lg font-medium text-gray-dark">Toplam</span>
  <span className="text-lg font-semibold text-primary">
    {finalTotal.toFixed(2)} ₺
  </span>
</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {is3DSActive && (
  <div className="fixed inset-0 z-[1000] bg-black/50 backdrop-blur-sm flex flex-col items-center justify-center px-6 text-center">
    <div className="w-12 h-12 mb-4 border-4 rounded-full border-white/60 border-t-transparent animate-spin"></div>
    <h3 className="mb-1 text-lg font-semibold text-white">Ödeme işleniyor…</h3>
    <p className="text-white/90">{overlayText}</p>
    <p className="mt-3 text-sm text-white/70">Lütfen bu pencereyi kapatmayın.</p>

    {/* 15sn sonra görünür */}
    {canCloseOverlay && (
      <button
        onClick={() => {
          setIs3DSActive(false);
          // Not: Overlay’i kapatmak 3D işlemini durdurmaz,
          // popup açıksa yine de tamamlanabilir.
          showNotification(
            'Doğrulama kapatıldı. 3D doğrulama penceresi açıksa işlem tamamlanabilir; aksi halde tekrar deneyebilirsiniz.',
            'warning'
          );
        }}
        className="px-4 py-2 mt-6 text-gray-900 transition bg-white rounded-md hover:bg-gray-100"
      >
        Doğrulamayı Kapat
      </button>
    )}
  </div>
)}
    </motion.div>
  );
};

export default CheckoutPage;